const paths = {
  listOptimization: '/optimizations/list',
  editOptimization: '/optimizations/edit'
};

export default paths;
